import { render, staticRenderFns } from "./ToolbarMenuRight.vue?vue&type=template&id=497f4f20"
import script from "./ToolbarMenuRight.vue?vue&type=script&lang=js"
export * from "./ToolbarMenuRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports